import {useContext, useEffect, useMemo, useState} from "react";
import {AppContext} from "../../Context/MainContext";
import TextFilterComponent from "../../Components/Filtering/TextFilter.component";
import {formatCurrency} from "../../utils/number.utils";
import Layout from "../../Layout/Layout.component";
import DataTable from "react-data-table-component";
import SelectFilter from "../../Components/Filtering/SelectFilter.component";

const NNCCIssuedPage = () => {

    const { transactions, selectedProject } = useContext(AppContext);
    const [data, setData] = useState<any[]>([]);
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [filterText, setFilterText] = useState('');
    const [filterFamily, setFilterFamily] = useState('');
    const [selectedRows, setSelectedRows] = useState<Set<string>>(new Set());

    const filteredItems = data
        .filter(item => item.client && item.client.toLowerCase().includes(filterText.toLowerCase()))
        .filter(item => {
            if (filterFamily === "Sin Familia") {
                return !item.family;
            } else if (filterFamily === "") {
                return true;
            } else {
                return item.family && item.family.toLowerCase().includes(filterFamily.toLowerCase());
            }
        });

    //check box
    const selectAll = filteredItems.length > 0 && selectedRows.size === filteredItems.length;

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectedRows(new Set());
        } else {
            setSelectedRows(new Set(filteredItems.map(item => item._id)));
        }
    };

    const toggleRow = (id: string) => {
        const newSelectedRows = new Set(selectedRows);
        if (newSelectedRows.has(id)) {
            newSelectedRows.delete(id);
        } else {
            newSelectedRows.add(id);
        }
        setSelectedRows(newSelectedRows);
    };

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };
        const handleClearFamily = () => {
            if (filterFamily) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterFamily('');
            }
        }
        return <>
            <SelectFilter
                selectOptions={["Sin Familia", ...selectedProject.families.filter((f:any) => f.selectable).map((f:any) => f.name)]}
                selected={filterFamily}
                onFilter={value => setFilterFamily(value)}
                onClear={handleClearFamily}
            />

            <TextFilterComponent onFilter={value => setFilterText(value)} onClear={handleClear} filterText={filterText} />
        </>;
    }, [filterText, filterFamily ,resetPaginationToggle]);


    useEffect(() => {
        if (transactions.length > 0) {
            let tmp = transactions.filter((transaction: any) => (transaction.type === 'NNCC' || transaction.type === 'NNDD') && transaction.received === false);
            let invoices = transactions.filter((transaction: any) => transaction.type === 'FACTURA');
            tmp.forEach((nncc: any) => {
                let invoice = invoices.find((invoice: any) => invoice.rawValue && invoice.rawValue.cabecera ? invoice.rawValue.cabecera.documento.numDocumento : (invoice.externalID.split("-").slice(-1) === nncc.rawValue.factAsociada));
                nncc.invoice = invoice;

            });
            setData(tmp);
        }
    }, [transactions]);

    let columns = [
        { name: "Fecha", selector: (row: any) => new Date(row.date).toLocaleDateString(), sortable: true, sortFunction: (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime() },
        { name: "Familia", selector: (row: any) => row.family || "-", sortable: true },
        { name: "Hoja de control", selector: (row: any) => row.controlSheet ? row.controlSheet.name : "-", sortable: true },
        { name: "Factura", selector: (row: any) => row.rawValue.factAsociada || "-" },
        { name: "Proveedor", selector: (row: any) => row.client, sortable: true },
        // { name: "Descripción", selector: (row: any) => row.description },
        { name: "Monto", selector: (row: any) => `$${formatCurrency(row.total)}`, sortable: true, sortFunction: (a: any, b: any) => parseInt(a.total) - parseInt(b.total) },
        { name: "Estado", selector: (row: any) => row.status },
        // { name: "Estado de pago", selector: (row: any) => row.paymentStatus },
        {
            wrap: true,
            maxWidth: "10%",
            name: (
                <div style={{ display: "flex", alignItems: "center" }}>
                    Pagado
                    <input
                        type="checkbox"
                        style={{ marginLeft: 8 }}
                        checked={selectAll}
                        onChange={toggleSelectAll}
                    />
                </div>
            ),
            cell: (row: any) => {
                const isChecked = selectedRows.has(row._id);
                return (
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => toggleRow(row._id)}
                    />
                );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };


    return (<Layout>
            <div className="container">
                <h1 className="text-2xl font-bold mb-4">Notas de crédito</h1>
                <DataTable
                    columns={columns}
                    data={filteredItems}
                    pagination={true}
                    paginationComponentOptions={paginationComponentOptions}
                    defaultSortFieldId={1}
                    defaultSortAsc={false}
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                    persistTableHead
                />
            </div>
        </Layout>

    );
}

export default NNCCIssuedPage;